import React from 'react'

const StatusMessage = ({ type, message }) => {
  if (!message) return null

  const styles = {
    error: 'bg-red-500/20 border-red-500/50 text-red-200',
    success: 'bg-green-500/20 border-green-500/50 text-green-200',
    warning: 'bg-yellow-500/20 border-yellow-500/50 text-yellow-200',
    info: 'bg-blue-500/20 border-blue-500/50 text-blue-200'
  }

  const icons = {
    error: '❌',
    success: '✅',
    warning: '⚠️',
    info: 'ℹ️'
  }

  return (
    <div className={`mt-6 border px-4 py-3 rounded-xl text-sm ${styles[type] || styles.info}`}>
      <div className="flex items-center gap-2">
        <span>{icons[type] || icons.info}</span>
        <span>{message}</span>
      </div>
    </div>
  )
}

export default StatusMessage